import React, { useRef, useState } from "react";
import { useError } from "../../context/errorContext";
import CloseIcon from '@mui/icons-material/Close';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import LockResetOutlinedIcon from '@mui/icons-material/LockResetOutlined';
import axiosInstance from "../../api/axiosInstance";
import useModalClose from "../../hooks/useModalClose";

const ChangePassword = ({ userId, onClose }) => {
    const [newPassword, setNewPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");

    const containerRef = useRef(null);

    useModalClose(containerRef, onClose);

    const { showMessage } = useError();

    const handleChangePassword = async () => {
        if (newPassword !== confirmPassword) {
            showMessage("Passwörter stimmen nicht überein!");
            return;
        }
        try {
            await axiosInstance.post(`auth/resetPassword/${userId}`, { password: newPassword });
            showMessage("Passwort erfolgreich geändert!");
            onClose()
        } catch (err) {
            console.error(err);
            showMessage("Fehler beim Ändern des Passworts!");
        }
    };

    return (
        <div className="background">
            <div className="modal middle" ref={containerRef}>
                <div className="topBar">
                    <h5>Passwort ändern</h5>
                    <button className="closeBtn" onClick={onClose}><CloseIcon /></button>
                </div>
                <form onSubmit={(e) => { e.preventDefault() }}>
                    <div className="group">
                        <LockOutlinedIcon />
                        <input
                            type="password"
                            placeholder="Neues Passwort"
                            value={newPassword}
                            onChange={(e) => setNewPassword(e.target.value)}
                        />
                    </div>
                    <div className="group">
                        <LockResetOutlinedIcon />
                        <input
                            type="password"
                            placeholder="Passwort bestätigen"
                            value={confirmPassword}
                            onChange={(e) => setConfirmPassword(e.target.value)}
                        />
                    </div>
                    <div className="bottom">
                        <div className="left">
                            <button onClick={handleChangePassword}>Ändern</button>
                            <button onClick={onClose} className="light">Abbrechen</button>
                        </div>
                    </div >
                </form >
            </div>
        </div >
    );
};

export default ChangePassword;